import { inject } from 'aurelia';

import { Helper } from '../resources/extensions/helper';

import { ApiService } from './api-service';

import { IWebsitePage } from '@chicksgroup/types';
import { websiteShortCode } from '../environment';
import { SessionService } from './session-service';

@inject(ApiService, Helper, SessionService)
export class WebsiteService {
    path = 'Website';
    pages: IWebsitePage[];

    constructor(private api: ApiService, private helper: Helper, private sessionService: SessionService) {
    }

    async getPagesByWebsiteShortcode() {
        if (this.pages) {
            return this.pages;
        }
        const language = await this.sessionService.getLanguage();
        const hrefLang = language?.language?.hrefLang || language?.hrefLang;
        const hrefLangParam = hrefLang && hrefLang !== 'en' ? `&hrefLang=${hrefLang}` : '';
        this.pages = await this.api.doGet(`${this.path}/Pages?websiteShortCode=${this.sessionService.getWebsiteShortcode() || websiteShortCode()}${hrefLangParam}`) as IWebsitePage[];
        return this.pages;
    }

    async getAllBeforeExecution(func) {
        await this.getPagesByWebsiteShortcode();
        return func() as IWebsitePage | IWebsitePage[] | { [Key: string]: IWebsitePage };
    }
}
